module.exports = __webpack_public_path__ + "img/people-dress-simple.8758c23d.svg";